import { render } from "./BillPreview.vue?vue&type=template&id=9a4ecd18&scoped=true"
import script from "./BillPreview.vue?vue&type=script&lang=js"
export * from "./BillPreview.vue?vue&type=script&lang=js"

import "./BillPreview.vue?vue&type=style&index=0&id=9a4ecd18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4ecd18"]])

export default __exports__